import type { Dispatch, GetState } from 'model/State';
import { Query } from 'redux-first-router';

export const ROUTE = 'mac/addon-license-view/ROUTE';

export const route = (licenseId: string, params?: Query) => ({
  type: ROUTE,
  payload: {
    licenseId,
  },
  meta: {
    query: params,
  },
});

export const routeIncludeParams = (licenseId: string) => (dispatch: Dispatch, getState: GetState) =>
  dispatch(route(licenseId, getState().location.query));
